import queryClient from "config/queryClient";
import { CACHE_KEYS, SOCKET_EVENTS, STORAGE_KEYS } from "constants/common";
import { useSocket } from "context/SocketContext";
import { useEffect } from "react";
import toast from "react-hot-toast";

export const useSubscribeSocket = () => {
  const socket = useSocket();

  useEffect(() => {
    if (socket) {
      socket.on(SOCKET_EVENTS.NEW_SURVEY_PUBLISHED, (data) => {
        const id = toast.loading("New survey published, Refreshing page...");
        localStorage.removeItem(STORAGE_KEYS.ACTIVE_STEP);
        localStorage.removeItem(STORAGE_KEYS.FORM_DATA);
        queryClient
          .invalidateQueries({
            queryKey: [CACHE_KEYS.QUESTIONER_ANSWER],
          })
          .then(() => {
            toast.success("Page refreshed successfully");
          })
          .catch(() => {
            toast.error("Error refreshing page");
          })
          .finally(() => {
            toast.dismiss(id);
          });
      });
    }

    return () => {
      if (socket) {
        socket.off(SOCKET_EVENTS.NEW_SURVEY_PUBLISHED);
      }
    };
  }, [socket]);
};
